import { Component, OnInit, Input, computed } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IUser } from 'common_library';
import { UserService } from 'src/app/services/entities/user.service';
import { UserProfileComponent } from '../master-detail-user-profile/user-profile.component';
import { MainStateService } from 'src/app/services/state/app-main-state.service';

@Component({
    selector: 'yf-profile-deletion',
    templateUrl: './profile-deletion.component.html',
    styleUrls: ['./profile-deletion.component.scss'],
    standalone: false
})
export class ProfileDeletionComponent implements OnInit {

  @Input() user: IUser;

  $sessionInProgress = computed(() => this.mainStateService.$sessions()?.length > 0);

  constructor(
    private userService: UserService,
    private modalController: ModalController,
    private mainStateService: MainStateService,
  ) { 
    
  }

  ngOnInit() {}

  async deleteProfile() {
    // Block deletion during an active charging session
    if (this.$sessionInProgress()) {
      return;
    }
    if (this.user) {
      await this.userService.deleteProfileConfirmed(this.user)
    }
  }

  async goBack() {
    await this.modalController.dismiss();
    if (this.user) {
      const modal = await this.modalController.create({
        component: UserProfileComponent,
        componentProps: {user:this.user, masterDetailShow: 'detail'},
        cssClass: 'yf-master-detail-modal' 
      })
      await modal.present();
    }
  }
}
